import reduxStore from "../../../../configureEnvStore";
import { CALL_BODY_SCREEN, DEVICE_ORIENTATION_TYPES, DEVICE_TYPES, ENABLED } from "../../../../constants/Constants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import navigatorService from "../../../../services/navigatorService";

// for mweb and web check is participant available
export const isInviteParticipantButtonVisible = (type) => {
    const deviceType = navigatorService.getDeviceType();
    const deviceOrientation = navigatorService.getOrientation();
    const { currentCallBodyScreen, isRemoteParticipantJoined } = reduxStore.getState().commonReducer;

    const isUploadFilesView = [CALL_BODY_SCREEN.NOTIFY_SCREEN, CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN].includes(currentCallBodyScreen);

    const isTabletLandscape =
        navigatorService.mobileIpad() &&
        [DEVICE_ORIENTATION_TYPES.THREE_LANDSCAPE, DEVICE_ORIENTATION_TYPES.FOUR_LANDSCAPE_REVERSED].includes(deviceOrientation);

    const isFeatureEnabled = GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag?.ONGOINGCALLINVITE === ENABLED && !isUploadFilesView;

    if (!isFeatureEnabled) {
        return false;
    }

    if (type === "more") {
        if (deviceType === DEVICE_TYPES.DESKTOP) {
            return false; // Desktop always returns false for "more"
        }

        return isTabletLandscape ? false : isRemoteParticipantJoined;
    }

    // Handling cases other than "more"
    if (deviceType === DEVICE_TYPES.DESKTOP || isTabletLandscape) {
        return true;
    }

    return !isRemoteParticipantJoined;
};
